import JobApplyCotainer from "../../Componant/JobSearch/JobApply";

const JobApply = () => {
  return (
    <div className="page-body">
      <JobApplyCotainer />
    </div>
  );
};

export default JobApply;
